import {filter} from 'rxjs/operators';
import {Component, OnInit, OnDestroy, ViewChild, ChangeDetectorRef, ElementRef} from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { MediaMatcher } from '@angular/cdk/layout';
import {MENU_ITEM_TYPE} from './side-nav-bar.model';
import {SideNavBarService} from './side-nav-bar.service';

@Component({
    selector: 'sfl-admin-layout',
    templateUrl: './side-nav-bar.component.html'
})

export class SideNavBarComponent implements OnInit, OnDestroy {
  @ViewChild('sideMenu', {static: false}) sideMenu;

  SMALL_WIDTH_BREAKPOINT = 1024;
  private subscription: Subscription;
  url: string;
  readonly MENU_TYPE = MENU_ITEM_TYPE;
  options = {
    collapsed: false,
    compact: false,
    boxed: false,
    dark: false,
    dir: 'ltr'
  };

  mediaMatcher: MediaQueryList;
  private readonly _mobileQueryListener: () => void;

  constructor(
    private _element: ElementRef,
    private router: Router,
    public sideNavBarService: SideNavBarService,
    media: MediaMatcher,
    changeDetectorRef: ChangeDetectorRef
  ) {
    this.mediaMatcher = media.matchMedia(`(max-width: ${this.SMALL_WIDTH_BREAKPOINT}px)`);
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mediaMatcher.addListener(this._mobileQueryListener);
  }

  ngOnInit(): void {
    this.url = this.router.url;
    this.subscription = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        document.querySelector('.app-inner > .mat-drawer-content > div').scrollTop = 0;
        this.url = event.url;
        this.runOnRouteChange();
      });
  }

  runOnRouteChange(): void {
    if (this.isOver()) {
      this.sideMenu.close();
    }
  }

  isOver(): boolean {
    return this.mediaMatcher.matches;
  }

  trackByFn(index, item) {
    return index;
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

}
